export const doubleClickMenuKey = "__pollchief_double_click_menu"

export const searchVoterResultKey = "__pollchief_search_voter_result"
